export const headlineFontFamily = `'Barrio'`;
export const normalFontFamily = `'VT323', sans-serif`;
export const normalFontSize = '24px';

/* 1: Text-color
   4: Background
   2: Menu background + Social Media + RightP
   3: Fixed Title + Underline */

export const color1 = '#424242'; // Charcoal
export const color4 = 'white';
export const color3 = 'rgba(242, 95, 92, 1)'; // Dark Orange
export const color5 = 'rgb(253, 238, 108)'; // Light Yellow
export const color2 = 'rgba(36, 123, 160, 1)'; // Blueish

export const black = '#424242'; // Charcoal
export const white = 'white';
export const red = 'rgba(242, 95, 92, 1)'; // Dark Orange
export const yellow = 'rgb(253, 238, 108)'; // Light Yellow
export const blue = 'rgba(36, 123, 160, 1)'; // Blueish
export const gray = '#828282';

export const menuBackground = color1;
export const menuTextColor = color5;

export const backgroundColor = color5;
export const textColor = color1;

export const socialMediaColor = color2;
export const socialMediaInverseColor = color4;

export const arrowColor = color3;



/** WEBPACK FOOTER **
 ** ./src/theme/variables.js
 **/